// src/pages/Workers/Documents/ExportDocumentsExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportDocumentsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Documents");
  const t = i18n.t.bind(i18n);
  worksheet.columns = [
    { header: t("documents.th.id") || "ID", key: "id", width: 8 },
    { header: t("documents.th.documentName") || "Document Name", key: "documentName", width: 30 },
    { header: t("documents.th.description") || "Description", key: "description", width: 30 },
    { header: t("documents.th.subject") || "Subject", key: "subject", width: 25 },
    { header: t("documents.th.fileType") || "File Type", key: "fileType", width: 15 },
    { header: t("documents.th.status") || "Status", key: "status", width: 18 },
    { header: t("documents.th.uploadedAt") || "Uploaded At", key: "date", width: 22 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Documents_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportDocumentsExcel;
